<template>
  <v-layout row>
    <v-flex d-flex>
      <v-card color="light-blue darken-1" dark hover to="/invoice/passedDue">
        <v-card-text style="height: 128px;">
          <v-layout align-center justify-center column fill-height>
            <v-progress-circular
              v-if="isLoading"
              size="70"
              width="7"
              color="white"
              indeterminate="indeterminate"
            ></v-progress-circular>
            <animated-number
              class="display-1 font-weight-light"
              v-if="!isLoading"
              :value="passedDueInvoice"
              :formatValue="formatToNumber"
              :duration="1000"
            ></animated-number>
            <div class="text-xs-center body-1">{{ $t("labels.passedDueInvoice") }}</div>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex d-flex>
      <v-card color="light-blue darken-1" dark hover to="/invoice/openInvoice">
        <v-card-text style="height: 128px;">
          <v-layout align-center justify-center column fill-height>
            <v-progress-circular
              v-if="isLoading"
              size="70"
              width="7"
              color="white"
              indeterminate="indeterminate"
            ></v-progress-circular>
            <animated-number
              class="display-1 font-weight-light"
              v-if="!isLoading"
              :value="OpenInvoice"
              :formatValue="formatToNumber"
              :duration="1000"
            ></animated-number>
            <div class="text-xs-center body-1">{{ $t("labels.openInvoice") }}</div>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import dashbaordService from "../../service.js";
import AnimatedNumber from "animated-number-vue";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      passedDueInvoice: 0,
      OpenInvoice: 0,
      isLoading: true
    };
  },
  components: {
    AnimatedNumber
  },
  computed: {
    ...mapGetters("global", ["currentUser"])
  },
  mounted() {
    this.getOpenInvoiceCount();
  },
  methods: {
    formatToNumber(value) {
      return `${value.toFixed(0)}`;
    },
    getOpenInvoiceCount() {
      dashbaordService.getOpenInvoiceCount().then(result => {
        this.passedDueInvoice = result.data.openInvoiceDueToday;
        this.OpenInvoice = result.data.openInvoiceCount;
        this.isLoading = false;
      });
    }
  }
};
</script>

<style scoped></style>
